import { SxProps, Typography, TypographyProps } from '@mui/material';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

interface Props extends TypographyProps {
  text: string;
}

const sxStyle: SxProps = {
  fontFamily: "Unimed-Sans",
  fontSize: "14px",
  lineHeight: "30px",
  letterSpacing: "0em",
  textAlign: "left",
  color: "#717171",
  textWrap: 'wrap',
}

const TableRegular: React.FC<Props> = ({ text, ...typographyProps }) => {

  const accessibility = useAccessibility();

  return (
    <Typography
      sx={sxStyle}
      style={accessibility.textStyleAccessibility}
      tabIndex={0}
      dangerouslySetInnerHTML={{ __html: text }}
      {...typographyProps}
    />
  )
}

export default TableRegular;